import { inject, Injectable } from '@angular/core';
import { SquareOrdersErrorsEndpoints } from 'app/core/enums/endpoints/gateway.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import { LoadSquareOrdersErrorsQueryParams } from '../../types';

@Injectable({
    providedIn: 'root',
})
export class SquareOrdersErrorsService {
    private _endpoint = SquareOrdersErrorsEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ------------------------------------------------------------------
    // @ API methods
    // ------------------------------------------------------------------

    getAll(params: LoadSquareOrdersErrorsQueryParams): Observable<any> {
        if (!params.production_id) {
            throw new Error('Production ID is required');
        }

        return this._apiService.getWithQueryParams(
            this._endpoint.getAll,
            params
        );
    }
}
